<template>
  <el-row>
        <AdminTable />
  </el-row>
</template>

<script>
import { mapState } from 'vuex'
import AdminTable from '../components/invoices/AdminTable.vue'

export default {
  components: { AdminTable },
  computed: {
    ...mapState('invoices', ['loading']),
  },
}
</script>